import React, { Component } from "react";
import { Table, Button, Col, Tooltip, Row } from "antd";
import axios from "axios";
import "./Pages.css";
import TituloLiquidarForm from '../components/TituloLiquidarForm';
import TituloFiltroForm from '../components/TituloFiltroForm';
import FichaFinanceiraPrintModal from '../relatorios/FichaFinanceiraPrintModal';
import PessoaFrame from '../components/PessoaFrame';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import { getUsuario, getTemPermissao } from "../utils/LoginManager";
import Colors from '../utils/Colors';

const { Column } = Table;

export default class extends Component {
  state = {
    listaRegistros: [],
    carregando: false,
    pagina: 1,
    limite: 10,
    total: 0,
    formVisivel: false,
    formFiltroVisivel: false,
    formLiqVisivel: false,

    vlrPagar: 0,
    vlrReceber: 0,
    vlrProvisao: 0,

    parcelasSelecionadasKeys: [],
    parcelasSelecionadas: [],

    registroParc: [],

    filtros: {
      tipoTela: 'FFI',
      buscaDataIni: moment(new Date(new Date().getFullYear() - 2, new Date().getMonth(), 1)).format('DD/MM/YYYY'),
      buscaDataFim: moment(new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).format('DD/MM/YYYY'),
      buscaControle: '',
      buscaNumero: '',
      buscaDescricao: '',
      buscaTipo: { key: 'X', },
      buscaSituacao: { key: 'A', },
      buscaPessoa: { key: '0' },
      buscaPlanoCta: { key: '0' },
      buscaCtaCorrente: { key: '0' },
      buscaTipoDoc: { key: '0' },
    }

  };

  componentDidMount() {
    const usuario = getUsuario();
    this.setState({
      usuario,
    });
  }

  componentDidUpdate(antProps, antState) {
    const { total, pagina, limite } = this.state;
    const ultimaPagina = Math.ceil(total / limite);
    if (pagina > 1 && pagina > ultimaPagina) {
      this.setState({
        pagina: ultimaPagina
      },
        this.getListaRegistros
      )
    }
  }

  getListaRegistros = () => {
    this.setState({ listaRegistros: [], carregando: true });
    const { pagina, limite } = this.state;

    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc, buscaSituacao,
      buscaDescricao } = this.state.filtros;

    // console.log('getListaRegistros', buscaPessoa)

    if ((buscaPessoa) && (buscaPessoa.key) && (buscaPessoa.key !== '0')) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/titulos/listaFichaFinanc', {
          params: {
            page: pagina,
            limite: limite,
            controle: buscaControle,
            numero: buscaNumero,
            descricao: buscaDescricao,
            tipo: buscaTipo.key,
            situacao: buscaSituacao.key,
            pessoa: buscaPessoa.key,
            ctaFin: buscaPlanoCta.key,
            tipoDoc: buscaTipoDoc.key,
            ctaCorrente: buscaCtaCorrente.key,
            dataIni,
            dataFim,
          }
        })
        .then(response => {
          const { data, total, current_page, per_page } = response.data;
          this.setState({
            listaRegistros: data,
            carregando: false,
            total: total,
            pagina: current_page,
            limite: Number(per_page),
          },
            this.getSaldos()
          );

        })
        .catch(erro => {
          console.warn(erro);
          this.setState({
            carregando: false,
          });
        });

    } else {
      this.setState({
        listaRegistros: [],
        carregando: false,
      });
    }
  };

  getSaldos = () => {
    this.setState({ vlrPagar: 0, vlrReceber: 0, vlrProvisao: 0, });

    const { buscaDataIni, buscaDataFim, buscaNumero, buscaControle, buscaTipo,
      buscaPessoa, buscaPlanoCta, buscaCtaCorrente, buscaTipoDoc, buscaSituacao,
      buscaDescricao } = this.state.filtros;

    if (buscaPessoa) {

      let dataIni = '';
      if ((buscaDataIni) && (buscaDataIni !== undefined)) {
        dataIni = moment(buscaDataIni, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }
      let dataFim = '';
      if ((buscaDataFim) && (buscaDataFim !== undefined)) {
        dataFim = moment(buscaDataFim, 'DD/MM/YYYY').format('YYYY-MM-DD');
      }

      axios
        .get('/titulos/somatorioFichaFinanc', {
          params: {
            controle: buscaControle,
            numero: buscaNumero,
            descricao: buscaDescricao,
            tipo: buscaTipo.key,
            situacao: buscaSituacao.key,
            pessoa: buscaPessoa.key,
            ctaFin: buscaPlanoCta.key,
            tipoDoc: buscaTipoDoc.key,
            ctaCorrente: buscaCtaCorrente.key,
            dataIni,
            dataFim,
          }
        })
        .then(response => {
          this.setState({
            vlrPago: response.data.vlrPag,
            vlrRecebido: response.data.vlrRec,
            vlrSaldo: parseFloat(response.data.vlrRec) - parseFloat(response.data.vlrPag),
            vlrReceber: response.data.vlrReceber,
            vlrPagar: response.data.vlrPagar,
            vlrProvisao: parseFloat(response.data.vlrReceber) - parseFloat(response.data.vlrPagar),
          });
        })
        .catch(erro => {
          console.warn(erro);
        });
    }
  };








  onLiquidarClick = () => {
    this.setState({
      formLiqVisivel: false,
      parcelasSelecionadasKeys: [],
      parcelasSelecionadas: [],
    }, this.getListaRegistros);
  };

  onCancelarLiqClick = () => {
    this.setState({
      formLiqVisivel: false
    })
  }

  onVisualizarClick = registro => {
    this.setState({ carregando: true });
    axios
      .get('/titulos/showParcela', {
        params: {
          idf: registro.tit_idf,
          parc: registro.tparc_parcela,
        }
      })
      .then(response => {
        const { data } = response;

        data.tparc_tipo_doc = {
          key: String(this.state.usuario.par_doc_padrao),
          label: this.state.usuario.td_descricao,
        }
        data.tparc_conta_corrente = {
          key: String(this.state.usuario.par_cta_corrente_padrao),
          label: this.state.usuario.cc_descricao,
        }

        data.pgto_data = moment().format('DD/MM/YYYY');
        data.tipoTela = 'LIQ';

        this.setState({
          formLiqVisivel: true,
          registroParc: data,
          carregando: false,
        })
      })
      .catch(error => {
        console.error(error.response);
        this.setState({
          carregando: false,
        })
      })
  };


  onLiquidarSelecionadasClick = () => {
    const { parcelasSelecionadas } = this.state;

    if (!parcelasSelecionadas.length) {
      return;
    }

    const parcelasValidas = parcelasSelecionadas.filter(
      item => item.situacao_parcela !== 'PAGO'
    );

    if (!parcelasValidas.length) {
      return;
    }

    const totalRestante = parcelasValidas.reduce((total, item) => {
      return total + parseFloat(item.pgto_vlr_restante || 0);
    }, 0);

    const registroParc = {
      tipoTela: 'LIQ_MULT',
      parcelas: parcelasValidas,
      qtdeParcelas: parcelasValidas.length,
      tparc_valor: totalRestante,
      pgto_vlr_restante: totalRestante,
      pgto_vlr_pago: totalRestante,
      pgto_data: moment().format('DD/MM/YYYY'),
      tparc_tipo_doc: {
        key: String(this.state.usuario.par_doc_padrao),
        label: this.state.usuario.td_descricao,
      },
      tparc_conta_corrente: {
        key: String(this.state.usuario.par_cta_corrente_padrao),
        label: this.state.usuario.cc_descricao,
      },
    };

    this.setState({
      formLiqVisivel: true,
      registroParc,
    });
  };

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;
    const { filtros } = this.state;
    filtros[id] = value;
    this.setState({
      [id]: value,
      pagina: 1
    },
      this.getListaRegistros
    );
  };

  onChangePessoa = event => {
    const { filtros } = this.state;
    filtros['buscaPessoa'] = event.buscaPessoa;
    this.setState(
      event,
      this.getListaRegistros
    );
  }





  onAbrirFiltroClick = () => {
    this.setState({
      formFiltroVisivel: true,
      filtros: {
        tipoTela: this.state.filtros.tipoTela,
        buscaDataIni: this.state.filtros.buscaDataIni,
        buscaDataFim: this.state.filtros.buscaDataFim,
        buscaNumero: String(this.state.filtros.buscaNumero),
        buscaControle: String(this.state.filtros.buscaControle),
        buscaDescricao: String(this.state.filtros.buscaDescricao),
        buscaTipo: this.state.filtros.buscaTipo,
        buscaSituacao: this.state.filtros.buscaSituacao,
        buscaPessoa: this.state.filtros.buscaPessoa,
        buscaPlanoCta: this.state.filtros.buscaPlanoCta,
        buscaCtaCorrente: this.state.filtros.buscaCtaCorrente,
        buscaTipoDoc: this.state.filtros.buscaTipoDoc,
      }
    })
  };

  onFiltrarClick = (filtros) => {
    this.setState({
      formFiltroVisivel: false,
      filtros,
    },
      this.getListaRegistros
    )
  };

  onCancelarFiltroClick = () => {
    this.setState({
      formFiltroVisivel: false,
    })
  };






  renderData = (data) => {
    if (data) {
      const dataMoment = moment(data);
      return (
        <span>
          {dataMoment.format('DD/MM/YYYY')}
        </span>
      )
    } else {
      return (
        <span></span>
      )
    }
  }


  renderAcoes = (registro) => {
    return (
      <div>
        {getTemPermissao('FichaFinanceiraPage', 'editar') ? (
          <Tooltip title={registro.situacao_parcela === 'PAGO' ? 'Abrir Parcela' : 'Liquidar Parcela'}>
            <Button type="primary" size="small" onClick={() => this.onVisualizarClick(registro)} icon="check" placement="topLeft" style={{ backgroundColor: registro.situacao_parcela === 'PAGO' ? Colors.primaryLight : Colors.primaryDark, borderColor: registro.situacao_parcela === 'PAGO' ? Colors.primaryLight : Colors.primaryDark }} />
          </Tooltip>
        ) : null}
      </div>
    );
  };

  renderValor = (vlr) => {
    return (
      <span> {numeral(parseFloat(vlr)).format('0,000.00')} </span>
    );
  };

  renderParcela = (tparc_parcela, registro) => {
    return (
      <span> {tparc_parcela + ' / ' + registro.qtde_parcelas} </span>
    );
  };

  renderCtaFin = (pc_abreviatura, registro) => {
    return (
      <Tooltip title={registro.pc_descricao}>{pc_abreviatura}</Tooltip>
    );
  };



  onTabelaChange = (pagination => {
    this.setState({
      pagina: pagination.current,
      limite: pagination.pageSize,
    },
      this.getListaRegistros
    )
  })


  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------
  // ---------------------------------------------------------------------------------------


  render() {
    const { listaRegistros, carregando, registroParc, formFiltroVisivel, formLiqVisivel,
      filtros, total, pagina, limite } = this.state;
    const { buscaPessoa } = this.state.filtros;

    // console.log('FichaFinanceiraPage.this.state: ', this.state);

    return (
      <div className="contentRoutesContainer">
        <span className="tituloPage">Ficha Financeira</span>
        <div className="divider-page" />

        <Row>
          <div className="pageFiltro" style={{ height: 50 }}>
            <Col xs={24} >

              <Row>
                <Col xs={24} sm={22} style={{ marginTop: -4 }} className="camposEspacoDireita">
                  <Col xs={12} style={{ width: 570 }}>
                    <PessoaFrame
                      label=""
                      id="buscaPessoa"
                      value={buscaPessoa}
                      width={"100%"}
                      onChange={this.onChangePessoa}
                    // descricaoPrimeiroItem="Selecione uma Pessoa"
                    />
                  </Col>

                  <Col xs={2} style={{ width: 110, marginLeft: 10, marginTop: 4 }}>
                    <Button
                      type="primary"
                      onClick={this.onAbrirFiltroClick}
                      className="botao-primary"
                      style={{ marginRight: 15 }}
                    >
                      Filtrar
                    </Button>
                  </Col>

                  <Col xs={2} style={{ width: 110, marginTop: 4 }}>
                    <FichaFinanceiraPrintModal
                      filtros={filtros}
                      vlrRecebido={this.state.vlrRecebido}
                      vlrPago={this.state.vlrPago}
                      vlrSaldo={this.state.vlrSaldo}
                      vlrReceber={this.state.vlrReceber}
                      vlrPagar={this.state.vlrPagar}
                      vlrProvisao={this.state.vlrProvisao}
                      pessoa={this.state.filtros.buscaPessoa.label}
                    />
                  </Col>

                  <Col xs={3} style={{ marginTop: 4 }}>
                    <Button
                      type="primary"
                      icon="check"
                      disabled={!this.state.parcelasSelecionadas.length}
                      onClick={this.onLiquidarSelecionadasClick}
                      className="botao-primary"
                      style={{ width: '100%' }}
                    >
                      Liquidar selecionadas
                    </Button>
                  </Col>

                  <Col xs={3} style={{ marginTop: 10 }}>
                    <span style={{ marginLeft: 10 }}>
                      {this.state.parcelasSelecionadas.length > 0
                        ? `${this.state.parcelasSelecionadas.length} parcela(s) selecionada(s)`
                        : ''}
                    </span>
                  </Col>

                </Col>
              </Row>

              <Row>
                <Col xs={24} md={24} style={{ height: 65, padding: 5, marginTop: -25 }}>

                  <Col xs={24} md={11} style={{ borderStyle: "solid", borderWidth: 2, color: Colors.primaryDark, marginRight: 30 }}>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVerde }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Entradas
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrRecebido)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVermelho }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Saídas
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrPago)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.primaryLight }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Saldo
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrSaldo)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                  </Col>

                  <Col xs={24} md={11} style={{ borderStyle: "solid", borderWidth: 2, color: Colors.primaryDark }}>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVerde }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            À Receber
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrReceber)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.fundoVermelho }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            À Pagar
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrPagar)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                    <Col xs={24} md={8} style={{ height: 65, padding: 5 }}>
                      <div style={{ height: "100%", borderStyle: "outset", borderWidth: 2, borderRadius: 5, backgroundColor: Colors.primaryLight }}>
                        <Row style={{ textAlign: "center", marginTop: 0, marginBottom: 5 }}>
                          <span style={{ fontSize: 17, fontWeight: "bold", color: Colors.primary }}>
                            Provisão
                          </span>
                        </Row>
                        <Row style={{ textAlign: "center" }}>
                          <Row style={{ marginTop: -5 }}>
                            <span style={{ fontSize: 14, fontWeight: "bold", color: "rgba(0, 0, 0, 0.45)" }}>{this.renderValor(this.state.vlrProvisao)}</span>
                          </Row>
                        </Row>
                      </div>
                    </Col>
                  </Col>
                </Col>
              </Row>
            </Col>



            <TituloFiltroForm
              visivel={formFiltroVisivel}
              onFiltrarClick={this.onFiltrarClick}
              onCancelarFiltroClick={this.onCancelarFiltroClick}
              filtros={filtros}
            />

            <TituloLiquidarForm
              visivel={formLiqVisivel}
              onLiquidarClick={this.onLiquidarClick}
              onCancelarLiqClick={this.onCancelarLiqClick}
              registroParc={registroParc}
            />

          </div>
        </Row>

        <Row>
          <div style={{ marginTop: 10 }}>
            <Table
              rowSelection={{
                selectedRowKeys: this.state.parcelasSelecionadasKeys,
                onChange: (selectedRowKeys, selectedRows) => {
                  this.setState({
                    parcelasSelecionadasKeys: selectedRowKeys,
                    parcelasSelecionadas: selectedRows,
                  });
                },
                getCheckboxProps: registro => ({
                  disabled: registro.situacao_parcela === 'PAGO',
                }),
              }}
              pagination={{
                total: total,
                pageSize: limite,
                current: pagina,
                pageSizeOptions: ['10', '20', '30', '40'],
                showSizeChanger: true,
              }}
              onChange={this.onTabelaChange}
              loading={{
                spinning: carregando,
                tip: 'Carregando. Aguarde...',
                size: "large"
              }}
              dataSource={listaRegistros}
              rowKey={(registro => registro.tit_idf + '_' + registro.tparc_parcela)}
            >
              <Column
                key="tparc_data_parcela"
                dataIndex="tparc_data_parcela"
                title="Data Venc"
                render={this.renderData}
                width={90}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pgto_data"
                dataIndex="pgto_data"
                title="Data Pagto"
                render={this.renderData}
                width={90}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tparc_parcela"
                dataIndex="tparc_parcela"
                title="Parcela"
                width={60}
                align="center"
                className="listaCadastro"
                render={this.renderParcela}
              />
              <Column
                key="tit_controle"
                dataIndex="tit_controle"
                title="Controle"
                width={60}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="tit_numero"
                dataIndex="tit_numero"
                title="Número"
                width={60}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="pc_abreviatura"
                dataIndex="pc_abreviatura"
                title="Conta"
                width={60}
                align="left"
                className="listaCadastro"
                render={this.renderCtaFin}
              />
              <Column
                key="tparc_valor"
                dataIndex="tparc_valor"
                title="Vlr Parcela"
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="pgto_vlr_pago"
                dataIndex="pgto_vlr_pago"
                title="Vlr Pago"
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="pgto_vlr_restante"
                dataIndex="pgto_vlr_restante"
                title="Vlr Restante"
                render={this.renderValor}
                width={70}
                align="right"
                className="listaCadastro"
              />
              <Column
                key="tit_descricao"
                dataIndex="tit_descricao"
                title="Descrição"
                width={150}
                align="left"
                className="listaCadastro"
              />
              <Column
                key="acoes"
                title=""
                render={this.renderAcoes}
                width={40}
                align="center"
                className="listaCadastro"
              />
            </Table>
          </div>
        </Row>
      </div >
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/FichaFinanceiraPage.js